import React from 'react';
import GamesPage from './Games';

const Games = props => <GamesPage {...props} />;

export default Games;
